<template>
  <div class="formCardPage">
    <el-card>
      <span class="title">报名信息</span>
      <div class="formItems">
        <el-form label-position="right" status-icon label-width="150px">
          <el-row>
            <!-- 报考职位 -->
            <el-col :span="8">
              <el-form-item label="报考职位:">
                <el-input v-model="applyForm.signup_job" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 报考姓名 -->
            <el-col :span="8">
              <el-form-item label="姓名:">
                <el-input v-model="applyForm.user_name" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 性别 -->
            <el-col :span="8">
              <el-form-item label="性别:">
                <el-input :value="applyForm.sex" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <!-- 出生日期 -->
            <el-col :span="8">
              <el-form-item label="出生日期:">
                <el-input :value="applyForm.birthday" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 身份证号 -->
            <el-col :span="8">
              <el-form-item label="身份证号:">
                <el-input v-model="applyForm.idcard" autocomplete="off" :maxlength="18" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 用户Id -->
            <el-col :span="8">
              <el-form-item label="报名编号:">
                <el-input v-model="applyForm.signup_id" autocomplete="off" :maxlength="18" disabled></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>

          <el-row>
             <!-- 民族 -->
             <el-col :span="8">
              <el-form-item label="民族:">
                <el-input v-model="applyForm.nation" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 籍贯 -->
            <el-col :span="8">
              <el-form-item label="籍贯:">
                <el-input v-model="applyForm.hometown" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 出生地 -->
            <el-col :span="8">
              <el-form-item label="出生地:">
                <el-input v-model="applyForm.homeplace" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>

          <el-row>
             <!-- 政治面貌 -->
             <el-col :span="8"><el-form-item label="政治面貌:"> <el-input v-model="applyForm.politics" autocomplete="off"
                  disabled></el-input> </el-form-item></el-col>
            <!-- 婚姻状况 -->
            <el-col :span="8">
              <el-form-item label="婚姻状况:">
                <el-input v-model="applyForm.marriage" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 身高 -->
            <el-col :span="8">
              <el-form-item label="身高:">
                <el-input v-model="applyForm.body_height" type="number" disabled></el-input>
              </el-form-item>
            </el-col>
            
          </el-row>

          <el-row>
            <!-- 所学专业 -->
            <el-col :span="8">
              <el-form-item label="所学专业:">
                <el-input v-model="applyForm.specialty" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 最高学历 -->
            <el-col :span="8">
              <el-form-item label="最高学历:">
                <el-input v-model="applyForm.education" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 毕业时间 -->
            <el-col :span="8">
              <el-form-item label="毕业时间:">
                <el-input v-model="applyForm.graduate_time" disabled></el-input>
              </el-form-item>
            </el-col>
            
          </el-row>

          <el-row>
            <!-- 毕业院校 -->
            <el-col :span="8">
              <el-form-item label="最高学历毕业院校:">
                <el-input v-model="applyForm.school" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="现工作单位:">
                <el-input v-model="applyForm.co_name" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系地址:">
                <el-input v-model="applyForm.address" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
           

          </el-row>

          <el-row>
             <!-- 邮编 -->
             <el-col :span="8">
              <!-- 贵州精准扶贫学生 -->
              <el-form-item label="贵州精准扶贫学生:">
                <el-input v-model="applyForm.poverty_student" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 邮箱 -->
            <el-col :span="8">
              <el-form-item label="邮箱:">
                <el-input v-model="applyForm.email" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 联系电话 -->
            <el-col :span="8">
              <el-form-item label="联系电话:">
                <el-input v-model="applyForm.tel" disabled></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="计算机能力/级别:">
                <el-input v-model="applyForm.computer_grade" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="外语能力(语种/级别):">
                <el-input v-model="applyForm.foreign_grade" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- 执业资格证书情况 -->
            <el-col :span="8">
              <el-form-item label="执业资格证书情况:">
                <el-input v-model="applyForm.doctor_grade" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="是否同意调剂:">
                <el-input v-model="applyForm.qualification" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row>
            <!-- 是否具备从业资格 -->
            <el-col :span="8">
              <el-form-item label="是否具备从业资格:">
                <el-input v-model="applyForm.qualification" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">

              <el-form-item label=" 职称:" prop="JobGrade">
                <el-input v-model="applyForm.job_grade" placeholder="请输入现有职称" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="考生来源地:">
                <el-input v-model="applyForm.skill" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <!-- 健康状况 -->
              <el-form-item label="健康状况:">
                <el-input v-model="applyForm.body_status" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 宗教信仰 -->
              <el-form-item label="宗教信仰:">
                <el-input v-model="applyForm.religion" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否为入境来黔或省外考生:" label-width="14em">
                <el-input v-model="applyForm.postcode" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="住院医师规培专业:" prop="DoctorTrainSpecialty">
                <!-- <el-input v-model="" placeholder="请输入住院医师规培专业" ></el-input> -->
                <el-input placeholder="请输入住院医师规培专业" v-model="applyForm.doctor_train_specialty" autocomplete="off"
                  disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="执业证类别:" prop="DoctorGradeType">
                <el-input v-model="applyForm.doctor_grade_type" placeholder="请输入执业证类别" autocomplete="off"
                  disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="执业证范围:" prop="DoctorGradeScope">
                <el-input v-model="applyForm.doctor_grade_scope" placeholder="请输入执业证范围" autocomplete="off"
                  disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 上传图片 -->
          <el-form-item label="近期免冠照:" ref="photoRef" label-width="120px">
            <!-- <img :src="applyForm.photo" alt="" /> -->
            <span> (点击查看大图)</span>
            <div class="boxList">
              <div class="imgBox" v-for="(item, index) in photoList" :key="index">
                <img style="width: 100px; height: 100px" v-image-preview :src="item" />
              </div>
            </div>
          </el-form-item>

          <el-form-item label="毕业证:">
            <!-- <img :src="applyForm.photo_diploma" alt="" /> -->
            <span> (点击查看大图)</span>
            <div class="boxList">
              <div class="imgBox" v-for="(item, index) in photoDiplomaList" :key="index">
                <img style="width: 100px; height: 100px" v-image-preview :src="item" />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="学位证:">
            <!-- <img :src="applyForm.photo_diploma" alt="" /> -->
            <span> (点击查看大图)</span>
            <div class="boxList">
              <div class="imgBox" v-for="(item, index) in PhotoDegreeList" :key="index">
                <img style="width: 100px; height: 100px" v-image-preview :src="item" />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="规培合格证/规培证明:">
            <!-- <img :src="applyForm.photo_degree" alt="" /> -->
            <span> (点击查看大图)</span>
            <div class="boxList">
              <div class="imgBox" v-for="(item, index) in PhotoTrainingList" :key="index">
                <img style="width: 100px; height: 100px" v-image-preview :src="item" />
              </div>
            </div>
          </el-form-item>

          <el-form-item label="资格证/规培经历证明:">
            <!-- <img :src="applyForm.photo_qualification" alt="" /> -->
            <span> (点击查看大图)</span>
            <div class="boxList">
              <div class="imgBox" v-for="(item, index) in photoQualificationList" :key="index">
                <img style="width: 100px; height: 100px" v-image-preview :src="item" />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="同意报考证明:">
            <!-- <img :src="applyForm.photo_degree" alt="" /> -->
            <span> (点击查看大图)</span>
            <div class="boxList">
              <div class="imgBox" v-for="(item, index) in PhotoApprovedList" :key="index">
                <img style="width: 100px; height: 100px" v-image-preview :src="item" />
              </div>
            </div>
          </el-form-item>



          <el-form-item label="外语证/职称证书(可多张合并上传):">
            <!-- <img :src="applyForm.photo_foreign" alt="" /> -->
            <span> (点击查看大图)</span>
            <div class="boxList">
              <div class="imgBox" v-for="(item, index) in photoforeignList" :key="index">
                <img style="width: 100px; height: 100px" v-image-preview :src="item" />
              </div>
            </div>
          </el-form-item>

          <!-- 工作经历 -->
          <el-row class="workDiv">
            <el-col>
              <el-form-item label="个人学习及工作经历:" label-width="100" disabled> </el-form-item>
            </el-col>
            <el-col>
              <el-row v-for="(item, index) in historyList" :key="index" class="jingliBottom">
                <el-col :span="5">
                  <p>开始时间:</p>
                  <el-date-picker placeholder="开始时间" v-model="item.beginDate" style="width: 100%;"
                    value-format="yyyy-MM-dd" disabled></el-date-picker>
                  <!-- <el-input v-model="item.beginDate" disabled></el-input> -->
                </el-col>
                <el-col :span="5" :offset="1">
                  <p>结束时间:</p>
                  <el-date-picker placeholder="结束时间" v-model="item.endDate" style="width: 100%;"
                    value-format="yyyy-MM-dd" disabled></el-date-picker>
                  <!-- <el-input v-model="item.endDate" disabled></el-input> -->
                </el-col>
                <el-col :span="5" :offset="1">
                  <p>工作单位:</p>
                  <el-input v-model="item.officeAddress" disabled></el-input>
                </el-col>
                <el-col :span="5" :offset="1">
                  <p>工作方式:</p>
                  <el-input v-model="item.workStyle" disabled></el-input>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <!-- 家庭成员 -->
          <el-row class="workDiv">
            <el-col>
              <el-form-item label="家庭成员及基本情况:" label-width="100"> </el-form-item>
            </el-col>
            <el-col>
              <el-row v-for="(item, index) in familyList" :key="index" class="jingliBottom">
                <el-col :span="4">
                  <p>成员姓名:</p>
                  <el-input v-model="item.name" disabled></el-input>
                </el-col>
                <el-col :span="4" :offset="1">
                  <p>与本人关系:</p>
                  <el-input v-model="item.relative" disabled></el-input>
                </el-col>
                <el-col :span="4" :offset="1">
                  <p>成员工作单位:</p>
                  <el-input v-model="item.officeAddress" disabled></el-input>
                </el-col>
                <el-col :span="4" :offset="1">
                  <p>成员年龄:</p>
                  <el-input v-model="item.age" type="number" disabled> </el-input>
                </el-col>
                <el-col :span="4" :offset="1">
                  <p>成员职业:</p>
                  <el-input v-model="item.job" disabled> </el-input>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="workDiv1">
            <el-form-item label="奖励惩戒情况:" class="">
              <el-input disabled type="textarea" v-model="applyForm.rewards_punishments"
                placeholder="请输入奖励惩戒情况"></el-input>
            </el-form-item>
          </el-row>
          <el-row class="workDiv1">
            <!-- <el-form-item label="专业证明及所学课程清单:" class="">
              <el-input disabled type="textarea" v-model="applyForm.specialty_remark"
                placeholder="请输入专业证明及所学课程清单"></el-input>
            </el-form-item> -->
            <el-form-item label="专业证明及所学课程清单:">
              <!-- <img :src="applyForm.photo_foreign" alt="" /> -->
              <span> (点击查看大图)</span>
              <div class="boxList">
                <div class="imgBox" v-for="(item, index) in specialtyRemarkList" :key="index">
                  <img style="width: 100px; height: 100px" v-image-preview :src="item" />
                </div>
              </div>
            </el-form-item>
          </el-row>
          <el-row class="workDiv1">
            <el-form-item label="其他需要说明事项:" class="">
              <el-input disabled type="textarea" v-model="applyForm.signup_remark" placeholder="请输入其他需要说明事项"></el-input>
            </el-form-item>
          </el-row>

        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      applyForm: {},
      bigImage: [],
      familyList: [],
      historyList: [],
      photoList: [],
      photoDiplomaList: [],
      photoforeignList: [],
      specialtyRemarkList: [],
      photoQualificationList: [],
      PhotoDegreeList: [],
      PhotoApproved: [],
      PhotoTrainingList: [],
      PhotoApprovedList: []
    }
  },
  created() {
    this.getSignupInfoApi()
  },
  methods: {
    async getSignupInfoApi() {

      const { data: res } = await this.$axios.get('api/signup/getSignupInfo', { params: { signupId: this.$route.query.singupId } })
      if (res.response_code == 200) {
        this.applyForm = res.data
        // this.applyForm.sex = this.applyForm.sex == 1 ? '男' : '女'
        this.applyForm.graduate_time = this.$moment(res.data.graduate_time).format('YYYY-MM-DD')

        this.familyList = JSON.parse(res.data.family)
        this.historyList = JSON.parse(res.data.history)
        this.photoList = JSON.parse(res.data.photo)
        this.photoDiplomaList = JSON.parse(res.data.photo_diploma)
        this.PhotoDegreeList = JSON.parse(res.data.photo_degree)
        this.photoforeignList = JSON.parse(res.data.photo_foreign)
        this.photoQualificationList = JSON.parse(res.data.photo_qualification)
        this.PhotoApprovedList = JSON.parse(res.data.photo_approved)
        this.PhotoTrainingList = JSON.parse(res.data.photo_training)
        this.PhotoApprovedList = JSON.parse(res.data.photo_approved)
        this.specialtyRemarkList = JSON.parse(res.data.specialty_remark)
        // 上传后可以删除
        this.photoList.forEach((item, index) => {
          this.photoList[index] = item
        })
        this.photoDiplomaList.forEach((item, index) => {
          this.photoDiplomaList[index] = item
        })
        this.PhotoDegreeList.forEach((item, index) => {
          this.PhotoDegreeList[index] = item
        })
        this.photoforeignList.forEach((item, index) => {
          this.photoforeignList[index] = item
        })
        this.photoQualificationList.forEach((item, index) => {
          this.photoQualificationList[index] = item
        })

        console.log(this.photoList)
        this.applyForm.signup_job = '【' + this.applyForm.regular + '】' + this.applyForm.signup_job
        // this.applyForm.birthday = res.data.birthday.slice(0, 10)
        // console.log('birth', res.data.birthday)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.formCardPage {
  .el-card {
    margin-top: 30px;
  }

  .title {
    font-size: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
  }

  // 显示证件
  .boxList {
    display: flex;

    .imgBox {
      margin-right: 15px;
    }

    img {
      border: 2px solid #ebeef5;
      padding: 10px;
      border-radius: 10px;
      object-fit: cover;
      cursor: pointer;
    }
  }

  .workDiv {
    .el-form-item {
      margin-bottom: 0;
    }

    p {
      padding: 5px;
      margin: 5px 0;
      font-size: 14px;
    }
  }

  .workDiv1 {
    margin-top: 20px;
  }
}
</style>
